import { $EntityLevel, EntityLevel } from '@suntex.fim/enums';

import { PLAYER_HUB_ROUTE, PREVIEW_ROUTE } from '../const';

/**
 * Build an entity-scoped route such as `/team/42/dashboard`, using the slug
 * that `@suntex.fim/enums` associates with the given level. Player routes omit
 * the id segment (`/player/dashboard`) since the player comes from the login.
 */
export function entityPath(
  level: EntityLevel,
  id: string | number | undefined,
  ...segments: string[]
): string {
  const slug = $EntityLevel.describe(level).slug;
  const tail = segments.filter(Boolean).join('/');
  if (level === EntityLevel.Player) {
    return tail ? `/${slug}/${tail}` : `/${slug}`;
  }
  return tail ? `/${slug}/${id}/${tail}` : `/${slug}/${id}`;
}

/**
 * Build the URL of a login's player dashboard from its entity level and preview
 * mode, appending `from` (the in-hub location to return to) as the hash.
 * Players always go to `/player`. Team leaders play their own team
 * (`/team/:id/play`) unless previewing. Everyone else (school/district/region)
 * always lands on the shared `/preview` dashboard.
 */
export function playerDashboardPath(
  level: EntityLevel,
  id: string | number | undefined,
  isPreview: boolean,
  from?: string | null,
): string {
  let path: string;
  if (level === EntityLevel.Player) {
    path = PLAYER_HUB_ROUTE;
  } else if (level === EntityLevel.Team && !isPreview) {
    path = entityPath(EntityLevel.Team, id, 'play');
  } else {
    path = PREVIEW_ROUTE;
  }
  return from ? `${path}#${from}` : path;
}

/**
 * Base path of the module routes: `/preview/modules` in preview mode,
 * `/modules` otherwise.
 */
export function modulesPath(isPreview: boolean): string {
  return isPreview ? `${PREVIEW_ROUTE}/modules` : '/modules';
}
